/**
 * Created by Administrator on 2019-01-30.
 */

import Vue from "vue";
import { post, fetch, Del, put } from "../../../ask/axios";
import { getCookie, delCookie } from "../../../ask/cookiejs";
import footerInfo from "../../../components/reception/public/footerInfo.vue";

// import startAirInput from '@/components/userCenter/air/component/startAirInput.vue'
// import endInfoAdd from '@/components/userCenter/air/component/endInfoAdd.vue'
import contraband from "@/components/userCenter/public/contraband.vue";

import BySelect from "@/components/Reception/public/bySelect.vue";
import ByOption from "@/components/Reception/public/byOption.vue";

import pickupStartCity from "@/components/userCenter/public/pickupStartCity.vue";
import pickupEndCity from "@/components/userCenter/public/pickupEndCity.vue";

import CheckOrder from "@/components/reception/CheckOrder.vue";
import Air from "@/components/reception/checkPrice/Air.vue";
import Express from "@/components/reception/checkPrice/Express.vue";
import PickUp from "@/components/reception/checkPrice/PickUp.vue";

import Promotion from "@/components/reception/indexPage/Promotion.vue";
import Advantages from "@/components/reception/indexPage/Advantages.vue";
import TabTrangle from "@/components/reception/indexPage/TabTrangle.vue";
import typeCargo from "../../../components/userCenter/public/typeCargo.vue";
import { get } from "jquery";

export default {
  name: "indexPage",
  //组件引用
  components: {
    PickUp,
    Air,
    CheckOrder,
    footerInfo,
    BySelect,
    ByOption,
    contraband,
    pickupStartCity,
    pickupEndCity,
    Promotion,
    Express,
    typeCargo,
    Advantages, TabTrangle
  },
  data() {
    return {
      tabActive: 0, //查价tab
      weightDialogVisible: false, //重量超500的弹框
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },

      //是否登录
      isLogin: false,
      userName: "", //用户名
      WCAQueryCountryKey: "", //wca成员显示的目的机场

      //弹框
      showModal: false,
      videoBox: false,

      //调查问券
      isShowTips1: false, //是否没有选择发货方式
      isShowTips2: false, //是否没有选择运输方式
      surRadio: null,
      surItem: [
        { val: 1, label: "<5" },
        { val: 2, label: "5-15" },
        { val: 3, label: "16-30" },
        { val: 4, label: "30+" }
      ],
      chkVal: [],
      surChkItem: [
        { val: 3, label: "Air freight" },
        { val: 1, label: "Express" },
        { val: 5, label: "LCL" },
        { val: 20, label: "FBA" },
        { val: 2, label: "International packet" }
      ],

      plaEmailText: "Working Email", //邮箱提示信息

      emPlaRed: false, //显示红色提示

      workEmail: "",
      isShowEmail: false, //邮箱格式是否正确

      //首页查价参数
      tabId: 1,

      //起运机场
      startAirPort: {},
      startAirPortList: [],
      bfStartAirPort: [],

      //目的机场
      destAirPort: {},
      destAirportList: [],
      bfDestAirPort: [],

      // //验证提示
      checkTip: {
        startTips: "Origin Airport",
        destTips: "Destination Airport",
        unitTips: "Total unit",
        cbmTips: "Total volume",
        weightTips: "Total weight"
      },
      startReqTips: false,
      destReqTips: false,

      unitVal: null,
      cbmVal: null,
      weightVal: null,
      //总量信息计算
      unitLabel: "CTNS",
      unitOptions: [
        { value: "CTNS", label: "Carton" },
        { value: "PLTS", label: "Pallet" },
        { value: "WOODEN CASE", label: "Wooden Case" },
        { value: "OTHER", label: "Other" }
      ],

      //货物种类弹框
      cargoBox: false,
      typeCargoShow: false,
      cargoVal: [],
      cargoInfo: [],
      GenCargoVal: false, //选择普货
      readInfo: false, //是否阅读违禁物品
      expressRead: false,//是否阅读快递违禁品声明
      showSHReport: false, //是否显示上海化工报告
      IsSHReport: null, //选择上海化工报告

      geCargoID: null, //普货ID
      porCargoID: null, //移动电源ID
      batteryCargoID: null, //纯电池ID

      isSum: false, //是否可以点击查价按钮

      //===============取件查价====================//
      //起运城市存值
      startCityNameEn: "",
      startProNameEn: "",
      startCityNameEn1: "",
      startCityKey: "",
      startCityNameCh: "",
      //目的城市存值
      endCityNameEn: "",
      endProNameEn: "",
      endCityNameEn1: "",
      endCityNameCh: "",
      endCityKey: "",

      mentTime: new Date(), //货好时间
      datePickerOptions: {
        disabledDate: time => {
          return (
            time.getTime() <
            new Date(new Date()).setDate(new Date().getDate() - 1)
          );
        }
      },
      selectedOptionsTip: false,
      plaCas: "",

      radioUnits: 0, //单位选择
      carWeight: null,
      carVolume: null,
      tipsTextVol: false,
      isShowRed: false,
      cargoInfoObj: [],
      isNormalGood: null,
      userType: 0,//是否海外同行  客户归属类型 0：直客，1：国内同行，2：海外同行 3:对接平台客户
      SaleEmail: "",
    };
  },
  computed: {
    currentTabComponent() {
      let map = {
        0: "Air",
        2: "PickUp",
        1: "Express"
      };
      return map[this.tabActive];
    },
    signUpLink() {
      return this.SaleEmail ? "/reg/registerPeer?SaleEmail=" + this.SaleEmail : "/reg/registerPeer";
    },
    // tabActive:{
    //   get(){
    //     if(this.$route.query.tab==='pickUp'){
    //       return 1
    //     }else{
    //       return 0
    //     }
    //   },
    //   set(){

    //   }
    // }
  },
  created() {
    //创建后
    let token = getCookie("X-BY-EnTOKEN");
    if (token && token != "null") {
      this.isLogin = true;
      this.userInfo();
    } else {
      this.isLogin = false;
      // this.getDestAirApi(); //目的机场数据
    }
    //console.log('this.isLogin ' +this.isLogin)
  },
  mounted() {
    let tab = this.$route.query.tab
    this.SaleEmail = this.$route.query.SaleEmail
    console.log(this.SaleEmail, 'this.SaleEmail');
    if (tab == 'pickUp') { this.tabActive = 2 } else if (tab == 'express') { this.tabActive = 1 } else { this.tabActive = 0 }
    //dom已经生成
    this.getCargoApi(); //货物种类接口
    // this.getStartAirportApi(); //起运机场接口

    //普货id
    this.geCargoID = sysCfg.air.Cargo.generalCargoID; //普货 ID
    this.porCargoID = sysCfg.air.Cargo.porCargoID; //移动电源ID
    this.batteryCargoID = sysCfg.air.Cargo.batteryCargoID; //纯电池ID
    //获取用户信息
    let U_info = JSON.parse(sessionStorage.getItem("customerInfos"));
    if (U_info) {
      this.userType = U_info.CustomerOwnerType;
    }

  },

  watch: {},

  methods: {

    //特殊货物取值
    byCargo(msg, isNormalGood) {
      this.isNormalGood = isNormalGood; // 是不是选每次 false 为选了，其余为没选
      this.cargoInfoObj = msg;
      console.log(this.cargoInfoObj, "this.cargoInfoObj");
    },
    //点击banner跳转防疫专题页面
    clkBanner() {
      let w = window.open();
      w.location.href = "/adepm";
    },

    //顶部用户信息
    userInfo() {
      // this.api.url = this.$api02 + "/api/CustomerInfo/GetCustomerInfoByToken";
      this.api.url = this.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByToken";
      this.api.param = {};
      post(this.api.url, this.api.param).then(res => {
        if (res.Results) {
          this.userName = res.Results.Mail;
          this.WCAQueryCountryKey = res.Results.WCAQueryCountryKey;
        }

        // this.getDestAirApi(); //目的机场数据
      });
    },
    //退出,删除cookies
    clkTopLogout() {
      delCookie("X-BY-EnTOKEN");
      window.location.href = "/reg/login";
    },
    //点击弹出完整视频
    advVideo() {
      this.showModal = true;
      this.videoBox = true;
      // this.$refs.pauseVideo.load()
      this.$refs.pauseVideo.play();
    },
    //关闭弹框
    getClose() {
      this.showModal = false;
      this.videoBox = false;
      this.$refs.pauseVideo.pause();
    },

    //调查问券
    //发货票数值改变
    chgRadVal() {
      if (this.surRadio) {
        this.isShowTips1 = false;
      }
    },
    //发货方式值改变
    chkSurveyItem(val) {
      // console.log('dddd' +  JSON.stringify(this.chkVal))
      if (this.chkVal.length > 0) {
        this.isShowTips2 = false;
      }
    },
    //邮箱验证方法
    ValidEmail() {
      if (this.workEmail) {
        let validEm = /^([a-zA-Z0-9_.-])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!validEm.test(this.workEmail) || this.workEmail.length > 50) {
          this.isShowEmail = true;
        } else {
          this.isShowEmail = false;
        }
      } else {
        this.isShowEmail = false;
      }
    },
    ValidEm() {
      //
      this.ValidEmail();
    },
    //邮箱值改变，isShowEmail 不显示
    valInput() {
      this.isShowEmail = false;
    },
    //点击注册
    clkRegBtn() {
      // console.log('this.isShowEmail ' + this.isShowEmail)
      if (
        !this.surRadio ||
        this.chkVal.length <= 0 ||
        !this.workEmail ||
        this.isShowEmail == true
      ) {
        if (!this.surRadio) {
          this.isShowTips1 = true;
        }
        if (this.chkVal.length <= 0) {
          this.isShowTips2 = true;
        }
        if (!this.workEmail) {
          this.emPlaRed = true;
          this.plaEmailText = "Please enter a valid email address";
        }
        return false;
      }

      let that = this;
      that.api.param = {
        OutStorePiece: that.surRadio,
        BusinessTypeStr: that.chkVal,
        VisitEmail: that.workEmail,
        Origin: 0
      };
      that.api.url = that.$api02 + "/api/EbayCustomer/CusRegInfo/AddCusRegInfo";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          //let w=window.open();
          window.location.href =
            "/reg/registerPeer?InvitaCode=" +
            "&Email=" +
            that.workEmail +
            "&EmailId=" +
            res.Results.Id;
        }
      });
    },

    //重量数字验证
    checkNum(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, "");
        if (ctrValue.indexOf(".") > -1) {
          let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 4);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf(".") > -1) {
            ctrValue = int + "." + arr[1];
          } else {
            ctrValue = int;
          }
        }
      }
      return ctrValue;
    },
    //体积数字验证
    checkCBMNum(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, "");
        if (ctrValue.indexOf(".") > -1) {
          let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 5);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf(".") > -1) {
            ctrValue = int + "." + arr[1];
          } else {
            ctrValue = int;
          }
        }
      }
      return ctrValue;
    },
    checkNumInt(ctrValue) {
      if (ctrValue) {
        //只能输入正整数
        ctrValue = ctrValue.replace(/\D/g, "");
      }
      if (ctrValue == 0) {
        ctrValue = "";
      }
      //获取小数点前面的值
      let arr = ctrValue.split(".");
      let le = arr[0].length;
      if (le > 4) {
        ctrValue = arr[0].substring(0, 4);
      }

      return ctrValue;
    },

    //首页查价切换
    clkTabTitle(tab) {
      this.tabId = tab;

      if (tab == 1) {
        this.$refs.pickupStartText.hiddenTips(); //起运城市
        this.$refs.pickupEndText.hiddenTips(); //目的城市
        this.tipsTextVol = false;
      } else if (tab == 2) {
        this.checkTip.startTips = "Origin Airport";
        this.checkTip.destTips = "Destination Airport";
        this.startReqTips = false;
        this.destReqTips = false;

        this.checkTip.unitTips = "Total unit";
        this.checkTip.cbmTips = "Total volume";
        this.checkTip.weightTips = "Total weight";
      }
    },

    //==================空运机场查价=========================//
    //起运机场
    getStartAirportApi() {
      let url = this.$api04 + "/Air/api/Airline/StartAirportQuery";
      fetch(url).then(res => {
        if (res.Results) {
          if (res.Results.length > 0) {
            this.startAirPortList = res.Results;

            let allCode3 = [];
            res.Results.forEach(code => {
              allCode3.push(code.AirportCode3);
            });
            allCode3 = allCode3.join(",");
            let obj = {
              AirportCode3: "All airports",
              AirportCode3Zj: allCode3,
              AirportNameEn: ""
            };

            this.startAirPortList.unshift(obj);
            //console.log('this.startAirPortList ' + JSON.stringify(this.startAirPortList) );

            this.bfStartAirPort = JSON.parse(
              JSON.stringify(this.startAirPortList)
            );
          }
        }
      });
    },
    startfilterOpt(val) {
      //起运机场搜索
      var search = val.toLowerCase();
      if (val) {
        this.startAirPortList = this.bfStartAirPort.filter(item => {
          let showTxt = `${item.AirportCode3}(${item.AirportNameEn})`;
          return showTxt.toLowerCase().indexOf(search) != -1;
        });
      } else {
        this.startAirPortList = this.bfStartAirPort;
      }
    },
    foucsData1() {
      this.startAirPortList = this.bfStartAirPort;
    },
    //目的机场-接口
    getDestAirApi() {
      let that = this;
      that.api.param = {
        DataClass: 7
      };
      this.api.url = this.$api04 + "/Basics/api/Airport/QueryPort";
      post(this.api.url, this.api.param).then(res => {
        if (res.Results) {
          res.Results.forEach(item => {
            if (item.DataCode) {
              item.DataCode = item.DataCode.replace(/(^\s*)|(\s*$)/g, ""); //去除前后空格
            }
          });
          this.destAirportList = res.Results;

          if (this.WCAQueryCountryKey) {
            this.destAirportList = this.destAirportList.filter(item => {
              if (
                String(item.Country_Key).toUpperCase() ==
                this.WCAQueryCountryKey
              ) {
                return item;
              }
            });
          }
          this.bfDestAirPort = JSON.parse(JSON.stringify(this.destAirportList));
        }
      });
    },
    //搜索
    filterDestOpt(val) {
      //目的机场搜索
      var search = val.toLowerCase();
      if (val) {
        this.destAirportList = this.bfDestAirPort.filter(item => {
          let showTxt = `${item.AirportCode3}(${item.AirportNameEn})`;
          return showTxt.toLowerCase().indexOf(search) != -1;
        });
      } else {
        this.destAirportList = this.bfDestAirPort;
      }
    },
    foucsData2() {
      this.destAirportList = this.bfDestAirPort;
    },

    blurUnitVal() {
      if (this.unitVal) {
        this.checkTip.unitTips = "";
      } else {
        this.checkTip.unitTips = "Required";
      }
    },
    blurCbmVal() {
      if (this.cbmVal) {
        this.checkTip.cbmTips = "";
      } else {
        this.checkTip.cbmTips = "Required";
      }
    },
    blurWeightVal() {
      if (this.weightVal) {
        this.checkTip.weightTips = "";
        if (this.weightVal >= 300) {
          this.weightDialogVisible = true;
        } else {
          this.checkTip.weightTips = "Required";
        }
      }
    },
    //货物种类接口-空运
    getCargoApi() {
      this.api.param = {
        AttrMain_Code: "KYSHSpecial"
      };
      // this.api.url = this.$api01 + "/api/Attribute/QueryList";
      this.api.url = this.$api04 + "/Basics/api/Attribute/QueryList";
      post(this.api.url, this.api.param).then(res => {
        this.cargoInfo = res.Results[0].valList;
        this.cargoInfo.forEach(item => {
          this.$set(item, 'Id', item.AttrVal_ID);
        })
      });
    },

    //选中哪些特殊货物
    chkGoodsItem(value) {
      if (value == this.geCargoID) {
        this.GenCargoVal = true;
        this.cargoVal = [this.geCargoID];
      } else {
        this.GenCargoVal = false;
      }

      if ($.inArray(value, this.cargoVal) >= 0) {
        if (value == this.geCargoID) {
          //是否勾选了普货
          this.cargoVal = [value];
        } else {
          //勾选中不是普货
          this.arrRemove(this.geCargoID, this.cargoVal);
        }
      }

      if ($.inArray(value, this.cargoVal) >= 0) {
        if (value == this.porCargoID) {
          //是否勾选了移动电源
          this.cargoVal = [value];
        } else {
          //勾选中不是移动电源
          this.arrRemove(this.porCargoID, this.cargoVal);
        }
      }

      if ($.inArray(value, this.cargoVal) >= 0) {
        if (value == this.batteryCargoID) {
          //是否勾选了纯电池
          this.cargoVal = [value];
        } else {
          //勾选中不是纯电池
          this.arrRemove(this.batteryCargoID, this.cargoVal);
        }
      }

      //空运选项：若所查询的起飞机场是上海，并且选择货物种类是内置电池1243、配套电池1242、让客户选择有无上海化工鉴定报告。选择无则不查出上海起飞的价格。
      let batArr = [
        sysCfg.air.Cargo.builtInBatID,
        sysCfg.air.Cargo.packedBatID
      ];
      let isTg = false; //是否存在以上的值
      //第一种方法： 查找两个数组之间的交集
      // batArr.forEach(item =>{
      //   if( $.inArray(item,this.cargoVal) > -1 ){
      //       isTg=true
      //       return false //结束循环
      //    }
      // })

      //第二种方法： 查找两个数组之间的交集
      let arrNew = [];
      arrNew = batArr.filter(v => this.cargoVal.includes(v));
      if (arrNew.length > 0) {
        isTg = true;
      }

      // console.log('startAirPort ' +  JSON.stringify(this.startAirPort));

      if (this.dataForms.from == "PVG" && isTg == true) {
        this.showSHReport = true; //显示上海化工材料
      } else if (
        this.dataForms.from == "All airports" &&
        this.dataForms.from.indexOf("PVG") != -1 &&
        isTg == true
      ) {
        //选择所有机场
        this.showSHReport = true; //显示上海化工材料
      } else {
        this.showSHReport = false; //不不显示上海化工材料
        this.IsSHReport = null;
      }

      if (this.showSHReport) {
        if (
          this.IsSHReport != null &&
          this.cargoVal.length > 0 &&
          this.readInfo
        ) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      } else {
        if (this.cargoVal.length > 0 && this.readInfo) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      }
    },

    //js给根据数组元素删除数组中指定元素,不是根据索引
    arrRemove(val, arr1) {
      var index = $.inArray(val, arr1);
      if (index > -1) {
        arr1.splice(index, 1);
      }
    },

    //是否选中上海化工报告
    chgShrep() {
      if (this.showSHReport) {
        if (
          this.IsSHReport != null &&
          this.cargoVal.length > 0 &&
          this.readInfo
        ) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      } else {
        if (this.cargoVal.length > 0 && this.readInfo) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      }
    },

    //违禁品弹框
    clkreadBox() {
      this.$refs.contraRef.clkOpenBox();
    },
    //是否选中阅读违禁物品
    chgRead() {
      if (this.showSHReport) {
        if (
          this.IsSHReport != null &&
          this.cargoVal.length > 0 &&
          this.readInfo
        ) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      } else {
        if (this.cargoVal.length > 0 && this.readInfo) {
          this.isSum = true;
        } else {
          this.isSum = false;
        }
      }
    },

    closeCargoBox() {
      this.cargoVal = [];
      this.showSHReport = false;
      this.GenCargoVal = false;
      this.readInfo = null;
      this.IsSHReport = null;
      this.isSum = false;
    },

    //============================取件查价===============================//
    //=========================起运城市，目的城市值======================//
    sentStartMsgSev(msg) {
      this.startCityNameCh = msg.StartProvNameCh + msg.StartCityNameCh;
      this.startCityNameEn = msg.StartCityNameEn;
      this.startProNameEn = msg.StartProvNameEn;
      this.startCityKey = msg.StartCityKey;
    },
    sentEndMsgSev(msg) {
      this.endCityNameCh = msg.EndProvNameCh + msg.EndCityNameCh;
      this.endProNameEn = msg.EndProvNameEn;
      this.endCityNameEn = msg.EndCityNameEn;
      this.endCityKey = msg.EndCityKey;
    },

    //重量，体积
    chgWei() {
      if (this.carWeight) {
        this.tipsTextVol = false;
      }
    },
    chgVol() {
      if (this.carVolume) {
        this.tipsTextVol = false;
      }
    },

    //===查价按钮=====//
    clkEnquiryBtn(params, method) {

      const datas = this.dataForms = params
      const strategy = {
        'pickUp': function () {
          this.tabActive = 2;
          // debugger
          // let time = new Date(datas.dateVal).Format("yyyy/MM/dd 23:59:59");
          this.$router.push({
            path: "/front/pickupService",
            query: {
              startCityNameEn: datas.fromItems.NameEn || datas.fromItems.City_NameEn,
              endCityNameEn: datas.toItems.NameEn || datas.toItems.City_NameEn,
              startProNameEn: datas.fromItems.Province_NameEn || datas.fromItems.Province_NameEn,
              endProNameEn: datas.toItems.Province_NameEn || datas.toItems.Province_NameEn,
              startCityNameCh: datas.fromItems.NameCh || datas.fromItems.City_NameCh,
              endCityNameCh: datas.toItems.NameCh || datas.toItems.City_NameCh,

              StartCityKey: datas.fromItems.CityKey || datas.fromItems.Id,
              endCityKey: datas.toItems.CityKey || datas.toItems.Id,
              PlanDate: new Date(datas.dateVal).Format("yyyy/MM/dd 23:59:59"),
              Weight: datas.weight,
              Volume: datas.volume,
              radioUnits: datas.units
            }
          });
        },

        'air': function () {
          if (localStorage.getItem('anyTimeNotContain') == 'true') {
            this.cargoVal = [sysCfg.air.Cargo.generalCargoID]
            // this.cargoInfo
            this.clkSum(0)
          } else {
            this.cargoBox = true;
          }
        },
        'express': function () {
          this.tabActive = 1;
          this.typeCargoShow = true;
          // this.$router.push({
          //   path: "/front/express",
          // })

        }
      }
      strategy[method].call(this)
    },


    //跳转查价
    clkSum(type) {

      let cargoStrID = this.cargoVal.join(","); //货物种类Id

      let cargoArrEn = []; //货物的英文名
      if (this.cargoInfo.length > 0) {
        //console.log("货物种类===哈哈哈哈");
        this.cargoInfo.forEach(e => {
          if (this.cargoVal.indexOf(e.Id) > -1) {
            cargoArrEn.push(e.AttrVal_Content);
          }
        });
      }
      cargoArrEn = cargoArrEn.join(",");



      const strategy = {

      }
      const datas = this.dataForms

      //获取用户信息
      let U_info = JSON.parse(sessionStorage.getItem("customerInfos"));
      if (U_info) {
        // 清空历史记录
        localStorage.removeItem('historyItems')
        localStorage.removeItem('queryItems')
        let obj = {
          destListBox: datas.end.split(","),//选中记录
          destList: datas.end.split(","),//查询记录
          CustomerID: U_info.CustomerID,//用户id
          DestCountry: datas.endItem.CountryNameCh//目的国家
        }
        //console.log("====保存的数据====",obj);
        localStorage.setItem('historyItems', JSON.stringify(obj))
        //保存首页查询记录
        localStorage.setItem('queryItems', JSON.stringify(datas))
      }




      //  当中全部   改下数据
      //  if(datas.from.length > 5) {
      //   datas.from='SZX,HKG,CAN,PVG,PEK,CGO,CSX,TSN,XMN,WUH,KMG,NNG,KHN,TAO,SHA,CTU,XIY,HGH,YNZ,TNA,CKG,URC,NTG,MFM,SJW,NKG,NGB'
      //  }
      //console.log("看看目的国家====== ", datas);
      this.$router.push({
        path: this.$store.state.user.token ? '/checkList/quotes' : "/front/air",
        query: {
          code1: datas.from,
          code2: datas.end,
          code1En: datas.startItem.AirportNameEn,
          code2En: datas.endItem.AirportNameEn,
          code2Country: datas.endItem.CountryNameEn,
          unitQty: datas.unit,
          unitLabel: datas.unitType,
          cbm: datas.volume,
          weight: datas.weight,
          cargoId: cargoStrID,
          cargoEn: cargoArrEn,
          IsSHReport: this.IsSHReport,
          startCityKey: datas.startItem.City_Key,
          CountryNameCh: datas.endItem.CountryNameCh
        }
      });



    },
    expressCheck() {
      if (!this.expressRead || !this.cargoInfoObj.cargoID.length) return;
      console.log(this.expressRead, this.cargoInfoObj);
      const datas = this.dataForms
      this.$router.push({
        path: "/front/express",
        query: {
          startCityKey: datas.startItem.CityKey,
          endCityKey: datas.endItem.CountryKey,
          cargoInfoObj: JSON.stringify(this.cargoInfoObj),
          volume: datas.volume || '',
          weight: datas.weight || '',
          //queryType == 1 总量计算 
          // unitValue:datas.unitType == "CTNS"?1:datas.unitType == 'PTLS'?2:datas.unitType == 'WOODEN CASE'?3:4
          // 对应查价页面Calculate to total shipmetn KG/CBM 选项以及查价接口参数Quanlity
          Quanlity: datas.unit,
          startCityEn: datas.fromLabel,
          desCountryEn: datas.endLabel,
          isNormalGood: this.isNormalGood,
          DeliveryKey: datas.startItem.CityKey
        }
      })
      console.log(datas, this.isNormalGood, "datas");

    },
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/reception/indexPage.js